import api, { apiWithoutResponseInterceptors } from '@/services/api';

const SmallCategoryScenario = {
  getCategoryTree: () => {
    return api.get('get_category_tree/');
  },
  getContractCategory: (textLines, languageCode) => {
    return apiWithoutResponseInterceptors.post('get_contract_category/', {
      text_lines: textLines,
      language_code: languageCode
    });
  }
};

export default SmallCategoryScenario;
